/* Animation Module */

const durationStd = '150ms';
const durationFast = '100ms';

const timingStd = 'ease-in-out';
const timingEaseIn = 'ease-in';

const std = {
  transition: `background-color ${durationStd} ${timingStd},
               color ${durationStd} ${timingStd}`,
};

const bg = {
  transition: `background-color ${durationStd} ${timingStd}`,
};

const text = {
  transition: `color ${durationStd} ${timingEaseIn}`,
};

const border = {
  transition: `border-color ${durationStd} ${timingStd}`,
};

const shadow = {
  transition: `box-shadow ${durationFast} ${timingEaseIn}`,
};

const anim = {
  std,
  bg,
  text,
  border,
  shadow,
};

export default anim;
